import {countryConfig} from '../../../country-config/country-config';

export const algoliaInit = require('search-insights');

export let userTokenAlgolia;

algoliaInit('init', {
  appId: countryConfig.algolia.id,
  apiKey: countryConfig.algolia.key,
  useCookie: true,
});

algoliaInit('getUserToken', null, (err, newUserToken) => {
  if (err) {
    return;
  }
  userTokenAlgolia = newUserToken;
});
